module.exports = __webpack_public_path__ + "static/img/aa6623a.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/bdyxgg/txgg_top.png
// module id = 630
// module chunks = 2